import React from "react";
import "../styles/gydeHero.css";
import heroBg from "../asserts/Home.png";

const GydeHero = () => {
  return (
    <section
      className="gyde-hero"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="gyde-overlay"></div>

      <div className="gyde-content">
        <h1>Gyde</h1>
        <p>
          HEALTH <span>•</span> SPORTS
        </p>
        <p>
          The AI-powered movement analysis platform that democratizes expert
          <br />
          observation, feedback, and coaching.
        </p>
      </div>
    </section>
  );
};

export default GydeHero;
